import { publicApi } from './api';

const googleReviewsService = {
  async getReviews() {
    try {
      const response = await publicApi.get('/google-reviews');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'No pudimos cargar las reseñas'
      };
    }
  }
};

export default googleReviewsService;
